import { Link } from 'react-router-dom';
import { ActivityItem, Button, Card, formatVor, interaktionInfo } from '@elbklar/ui';

interface Activity {
  id: string;
  interaction_type: string;
  subject: string;
  occurred_at: string;
  customer_id?: string;
  partner_id?: string;
}

interface ActivityFeedWidgetProps {
  activities: Activity[];
}

export function ActivityFeedWidget({ activities }: ActivityFeedWidgetProps) {
  return (
    <Card
      title="Letzte Aktivitäten"
      actions={
        <Button asChild size="sm" variant="ghost">
          <Link to="/interactions">Alle anzeigen</Link>
        </Button>
      }
    >
      {activities.length > 0 ? (
        <div>
          {activities.map((activity, i) => {
            const info = interaktionInfo(activity.interaction_type);
            return (
              <ActivityItem
                key={activity.id}
                type={info.type}
                title={activity.subject}
                meta={`${info.label} · ${formatVor(activity.occurred_at)}`}
                last={i === activities.length - 1}
              />
            );
          })}
        </div>
      ) : (
        <p className="py-4 text-center t-small text-muted-foreground">Neue Interaktionen erscheinen hier.</p>
      )}
    </Card>
  );
}
